import React from "react"
import { Select } from ".."

export default props => {
  const { length = 0 , start = 0 , ...otherProps} = props
  return (
    <Select {...otherProps} >
      {(
        () => {
          const options = []
          for(let i = 0; i < length; i++) {
            options.push(
              <option key={i} value={i + start}>
                {i + start}
              </option>
            )
          }
          return options
        }
      )()}
    </Select>
  )
}
